export default "__VITE_ASSET__PmcKhh5K__"